export default __webpack_public_path__ + "static/Statistics 3-c3ea157ca3813a6c029c4e317e5a8137.svg";